export default __webpack_public_path__ + "static/media/dog5.404767c3.png";